import LocationGraphics from './LocationGraphics';
let assetArray = [{
    id: 'auntyKewaBg',
    path: '././assets/images/aunty-kewa-bg.svg'
}];
export default class AuntyKewaGraphics extends LocationGraphics {
    constructor() {
        super('auntyKewaGraphics');
        this.assetArray = assetArray;
    }

    addGraphics(container) {
        container.add(this.utils.addImage(this.parent, {
            id: 'auntyKewaBg'
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'flax1',
            x: -175,
            y: -250,
            scale: 0.43,
            flip: true
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'flax1',
            x: 425,
            y: -360,
            scale: 0.52
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'flax1',
            x: 600,
            y: -180,
            scale: 0.43,
            flip: true
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'flax1',
            x: 100,
            y: 0,
            scale: 0.44,
            english: 'flax plant',
            maori: 'harakeke',
            hit: [
                [129, 1116],
                [245, 465],
                [458, 13],
                [796, 457],
                [938, 1089]
            ],
            location: 'flax'
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'auntyKewa',
            x: 447,
            y: 100,
            english: 'Aunty Kewa',

            hit: [
                [131, 541],
                [75, 241],
                [147, 7],
                [203, 0],
                [259, 90],
                [296, 320],
                [247, 465]
            ],
            location: 'aunty'
        }));
        container.add(this.utils.addImage(this.parent, {
            id: 'flaxBundle',
            x: 257,
            y: 471,
            english: 'flax bundle',
            maori: 'pūpū harakeke',
            location: 'bundle',
            scale: 0.5
        }));

        super.addGraphics();
    }
}